<template>
    <SOSlotBase :bg-grey="true" :is-search="isSearch">
        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="'Blast WA'"
                :type="'back'"
                :show-search="true"
                @back="toDashboard"
                @search="openSearch"
            />
        </template>

        <template v-slot:skeleton>
            <div class="p-x-20 p-y-12" v-if="isFetching">
                <SOCardTransaksiSkeleton />
            </div>
        </template>

        <template v-slot:empty-state>
            <SOEmptyState
                v-if="listNullNoSearch"
                :message="'Belum pernah melakukan Blast WA'"
                :sub-message="'Klik tombol + untuk mengirim Blast'"
            />
            <SOEmptySearchState v-if="listNullSearch" @action="setSearch('')" />
        </template>

        <template v-slot:search-bar>
            <SOSearchBar
                v-if="isSearch"
                :context="'WA Blast'"
                :placeholder="`Ketik minimal 2 karakter`"
                :value="search"
                :data-count="totalHistory"
                :search-information="`Nama blast`"
                :waiting="searchLoading"
                @return-search-value="
                    (v) => {
                        setSearch(v);
                    }
                "
                @do-search="(v) => doSearch({ iddevice: selectedWaDevice.iddevice, key: v })"
                @loading="loadingSearch"
                @close="closeSearch({ iddevice: selectedWaDevice.iddevice })"
            />
        </template>

        <template v-slot:content>
            <FilterWABlast />
            <div class="separator"></div>
            <div class="p-x-20 p-y-12 bg-white d-flex" v-if="!isSearch && !isFetching">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15.8326 3.33366C15.887 3.33366 15.9421 3.33897 15.9959 3.34967C16.1576 3.38183 16.3061 3.46119 16.4226 3.57774C16.5392 3.69428 16.6185 3.84277 16.6507 4.00442C16.6828 4.16607 16.6663 4.33363 16.6033 4.4859C16.5402 4.63817 16.4334 4.76832 16.2963 4.85989C16.1593 4.95145 15.9982 5.00033 15.8334 5.00033H15V4.16699C15 4.00218 15.0489 3.84106 15.1405 3.70402C15.232 3.56698 15.3622 3.46017 15.5145 3.39709C15.6158 3.35511 15.724 3.33376 15.8326 3.33366ZM13.4763 3.33366C13.3822 3.5999 13.3334 3.8816 13.3334 4.16699V15.8337C13.3334 16.0547 13.2456 16.2666 13.0893 16.4229C12.933 16.5792 12.721 16.667 12.5 16.667C12.279 16.667 12.067 16.5792 11.9108 16.4229C11.7545 16.2666 11.6667 16.0547 11.6667 15.8337V14.167C11.6667 13.7068 11.2936 13.3337 10.8334 13.3337H5.00002V5.00033C5.00002 4.5583 5.17562 4.13438 5.48818 3.82182C5.80074 3.50926 6.22466 3.33366 6.66669 3.33366H13.4763ZM10.143 16.667H5.00002C4.55799 16.667 4.13407 16.4914 3.82151 16.1788C3.50895 15.8663 3.33335 15.4424 3.33335 15.0003H10V15.8337C10 16.1203 10.0492 16.4018 10.143 16.667ZM3.33335 13.3337H2.50002C2.03978 13.3337 1.66669 13.7068 1.66669 14.167V15.0003C1.66669 15.8844 2.01788 16.7322 2.643 17.3574C3.26812 17.9825 4.11597 18.3337 5.00002 18.3337H12.5C13.1631 18.3337 13.7989 18.0703 14.2678 17.6014C14.7366 17.1326 15 16.4967 15 15.8337V6.667H15.8334C16.3278 6.667 16.8112 6.52037 17.2223 6.24567C17.6334 5.97097 17.9538 5.58052 18.1431 5.1237C18.3323 4.66689 18.3818 4.16422 18.2853 3.67927C18.1889 3.19432 17.9508 2.74886 17.6011 2.39923C17.2515 2.0496 16.806 1.81149 16.3211 1.71503C16.1589 1.68278 8.49709 1.66684 8.33335 1.66699M8.33335 1.66699L6.66669 1.66699C5.78263 1.66699 4.93479 2.01818 4.30966 2.64331C3.68454 3.26843 3.33335 4.11627 3.33335 5.00033V13.3337M6.66669 6.66699C6.66669 6.20676 7.03978 5.83366 7.50002 5.83366H10.8334C11.2936 5.83366 11.6667 6.20676 11.6667 6.66699C11.6667 7.12723 11.2936 7.50033 10.8334 7.50033H7.50002C7.03978 7.50033 6.66669 7.12723 6.66669 6.66699ZM6.66669 10.0003C6.66669 9.54009 7.03978 9.16699 7.50002 9.16699H10.8334C11.2936 9.16699 11.6667 9.54009 11.6667 10.0003C11.6667 10.4606 11.2936 10.8337 10.8334 10.8337H7.50002C7.03978 10.8337 6.66669 10.4606 6.66669 10.0003Z"
                        fill="#206CFF"
                    />
                </svg>
                <div
                    class="f-semi f-16 f-c-blue"
                    style="padding-left: 12px"
                    v-if="validateAccess('whatsappBlast.template')"
                    @click="$router.push('/wa-blast/template-pesan')"
                >
                    Template pesan ({{ countTemplate }})
                </div>
            </div>

            <div class="p-x-20 p-y-16">
                <div class="f-regular f-16 p-d-16 f-c-midgrey" v-if="!isSearch && validateAccess('whatsappBlast.read')">
                    Riwayat Blast
                </div>
                <CardWABlast :data-list="listHistory" />
            </div>

            <div class="p-d-72" v-if="!isFetching"></div>

            <SOFABRegular @add=" ()=>{$router.push({ name: 'wa_blast.create.form' });  smartTrackingClick('add_blast_whatsapp');}"  />
        </template>
    </SOSlotBase>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import FilterWABlast from "@/modules/wa-blast/components/FilterWABlast";
import CardWABlast from "@/modules/wa-blast/components/CardWABlast";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import { moduleName } from "./../store/state";

export default {
    name: "WABlastList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOCardTransaksiSkeleton,
        SOEmptyState,
        SOEmptySearchState,
        SOSearchBar,
        FilterWABlast,
        CardWABlast,
        SOFABRegular,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            endItemofPage: "endItemofPage",
            lastPosition: "lastPosition",
            displayItem: "displayItem",
            listHistory: "listHistory",
            totalHistory: "totalHistory",
            countTemplate: "countTemplate",
            selectedWaDevice: "selectedWaDevice",

            search: "search",
            searchLoading: "searchLoading",
            isSearch: "isSearch",
        }),
        listNull() {
            return this.totalHistory === 0 && !this.isFetching;
        },
        listNullNoSearch() {
            return this.listNull && !this.isSearch;
        },
        listNullSearch() {
            return this.listNull && this.isSearch && !this.searchLoading && this.search.length > 2;
        },
    },
    async mounted() {
        await this.init();
        await this.scrollTo();
        await this.fixCard();
        this.smartTrackingView("blast_whatsapp");

    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.path.split("/")[1] !== "wa-blast") {
                vm.resetListHistory();
                vm.resetPagination();
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "dashboard") {
            this.setLastItem();
        }
        next();
    },
    methods: {
        ...mapActions({
            fetchListHistory: `${moduleName}/fetchListHistory`,
            fetchCountTemplate: `${moduleName}/fetchCountTemplate`,

            setEndItemofPage: `${moduleName}/setEndItemofPage`,
            setLastPosition: `${moduleName}/setLastPosition`,
            resetPagination: `${moduleName}/resetPagination`,
            resetListHistory: `${moduleName}/resetListHistory`,
            openSearch: `${moduleName}/openSearch`,
            closeSearch: `${moduleName}/closeSearch`,
            setSearch: `${moduleName}/setSearch`,
            loadingSearch: `${moduleName}/loadingSearch`,
            doSearch: `${moduleName}/doSearch`,
        }),
        async init() {
            if (this.listHistory.length === 0) {
                await this.resetPagination();
                await this.fetchListHistory();
                await this.fetchCountTemplate();
            }
        },
        scrollTo() {
            setTimeout(() => {
                let el = document.getElementById(`${this.lastPosition.id}`);
                if (el) {
                    setTimeout(() => {
                        el.scrollIntoView();
                        document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                    }, 100);
                }
            }, 300);
        },
        setLastItem() {
            let newDP = this.displayItem.sort(function(a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newDP[0]) {
                this.setLastPosition(newDP[0]);
            }
        },

        toDashboard() {
            this.$router.push({ name: "dashboard" });
        },
        async fixCard() {
            setTimeout(() => {
                $(".card").css({ "padding-bottom": "0" });
            }, 500);
        },
    },
};
</script>
